var map = {
	"./baozhuang.svg": "WTYB",
	"./caigou.svg": "SGZz",
	"./caigou1.svg": "Pk7c",
	"./class.svg": "KTQf",
	"./erweima.svg": "MS7T",
	"./guanli-fill.svg": "TeSp",
	"./guanli.svg": "EKOC",
	"./jiagong.1.svg": "yGzT",
	"./jiagong.svg": "2uHq",
	"./jiance.svg": "68uh",
	"./jibenxinxi.svg": "B/DR",
	"./jiesuan.svg": "MSVZ",
	"./other.svg": "/B26",
	"./piciguanli.svg": "EWMg",
	"./production.svg": "ku9W",
	"./set.svg": "J28p",
	"./shebei.svg": "1JOB",
	"./shengchanguanli.svg": "kxFc",
	"./shengchanliucheng.svg": "8tI3",
	"./shiping.svg": "V1g7",
	"./shouye-copy.svg": "J5Lv",
	"./wulianwang.svg": "zZZk",
	"./xiangmushenbao.svg": "TrnD",
	"./xiaoshou.svg": "cS1h",
	"./xuncha.svg": "FJey",
	"./yunshu.svg": "ro6E"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 67